module.exports = __webpack_public_path__ + "static/img/fullscreen-image_training_768.ee00a9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_training_768.png
// module id = Bm7E
// module chunks = 0